// Stub for BassoonProvider — not used in xtracker.
var BassoonProvider = function(){
	var me = {};
	me.init = function(){};
	return me;
}();

export default BassoonProvider;
